import React from 'react';
import { Link } from 'react-router-dom';
import './Marketing.css';

const SignupPage = () => {
    return (
        <div className="login-container">
            <div className="login-card" style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>🔒</div>
                <h2 className="login-title">No Sign-Up Required</h2>
                <p style={{ color: '#8892B0', marginBottom: '1.5rem', lineHeight: '1.6' }}>
                    Access to RoofingAssist is granted by your workspace owner.<br />
                    Ask your team's GHL account owner to add and enable you.
                </p>
                <p style={{ color: '#8892B0', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
                    Once added, you'll receive an email at your GHL address.<br />
                    Use the <strong style={{ color: '#64FFDA' }}>magic link</strong> to sign in — no password needed.
                </p>
                <Link to="/login" className="btn-primary" style={{ display: 'block', textDecoration: 'none' }}>
                    ← Back to Sign In
                </Link>
            </div>
        </div>
    );
};

export default SignupPage;
